/**
 * Configuración de mapas para el módulo de rastreo
 *
 * Permite cambiar fácilmente entre OpenLayers y Google Maps
 */

export const MAP_CONFIG = {
  // Proveedor de mapas: 'openlayers' | 'google'
  // Para cambiar a Google Maps, cambiar a 'google' y agregar API Key
  provider: 'google',

  // API Key de Google Maps (solo necesario si provider = 'google')
  googleMapsApiKey: 'AIzaSyCRKBHV4aSNChGkrwy5h0C5JaH12NuCQOc',

  // Centro inicial del mapa (Lima, Perú)
  defaultCenter: {
    lat: -12.046374,
    lng: -77.042793
  },

  // Zoom inicial
  defaultZoom: 13,

  // Zoom máximo
  maxZoom: 19,

  // Zoom mínimo
  minZoom: 5,

  // Intervalo de actualización de marcadores (ms)
  // Nota: El backend envía cada 20 segundos por trabajador
  updateInterval: 20000,

  // Colores de marcadores según estado
  markerColors: {
    online: '#4CAF50',   // Verde - menos de 1 minuto
    idle: '#FFC107',     // Amarillo - 1-5 minutos
    offline: '#9E9E9E'   // Gris - más de 5 minutos
  },

  // Iconos de marcadores
  markerIcons: {
    online: '/assets/markers/marker-online.png',
    idle: '/assets/markers/marker-idle.png',
    offline: '/assets/markers/marker-offline.png'
  },

  // Configuración de polylines (rutas)
  polylineStyle: {
    strokeColor: '#1976D2',
    strokeOpacity: 0.8,
    strokeWeight: 3
  },

  // Configuración de clustering (agrupar marcadores cercanos)
  clustering: {
    enabled: true,
    distance: 40, // Distancia mínima entre marcadores para agrupar (px)
    minPoints: 3  // Mínimo de puntos para formar un cluster
  },

  // Límites por defecto para consultas
  defaultLimits: {
    historyPoints: 100,
    maxHistoryDays: 30
  }
};

export default MAP_CONFIG;
